import { queryOptions, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/api/utils/queryKeys';
import { Modal } from '@/components/ModalRenderer/Modal';
import { PortableTextContent } from '@/components/shared';
import { cmsApi } from '@/integrations/sanity/api';

const sekkiQueryOptions = () =>
  queryOptions({
    queryKey: queryKeys.cms.sekki,
    queryFn: cmsApi.getSekki,
    staleTime: Infinity,
  });

const SekkiCredit = () => {
  const { data: sekkiData } = useQuery(sekkiQueryOptions());

  if (!sekkiData) {
    return null;
  }

  return (
    <Modal title="Sekki">
      <div className="flex flex-col gap-4">
        {sekkiData?.contentBlockGroup?.contentBlocks?.map(contentBlock => (
          <div key={contentBlock._key}>
            <div className="flex flex-col gap-4">
              <h3 className="text-body-regular">{contentBlock.title}</h3>
              <div className="space-y-2">
                {!!contentBlock.body && <PortableTextContent value={contentBlock.body} />}
              </div>
            </div>
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SekkiCredit;
